import type { CatalogTree } from '../types';

// The header's global Merchant search (admin panel screens §2).
export const shell = {
  merchantSearch: {
    label: 'İşletme ara',
    placeholder: 'İşletme ara',
    empty: 'İşletme bulunamadı.',
  },
  // What each nav badge counts, read to a screen reader in place of the shared "{count} yeni".
  badges: {
    alerts: '{count} açık uyarı',
    failedPayments: '{count} başarısız ödeme',
  },
} as const satisfies CatalogTree;
